import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { serverurl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserdataService {
  data = new BehaviorSubject<any>(null);
  constructor(
    private http: HttpClient,
  ) { }

  public getUserDataByKey(key: string) {
    const data = this.data.getValue();
    if (data) {
      return data[key];
    }
    return null;
  }

  async updateUserData(userdata: any) {
    this.data.next(userdata);
  }

  async updateUserDataOnServer(data: any): Promise<boolean> {
    return await new Promise((resolve) => {
      this.http.post(serverurl + '/user/data', data).subscribe({
        next: (data: any) => {
          resolve(true);
        },
        error: (err) => {
          resolve(false);
        }
      });
    });

  }
  async uploadAvatar(avatar: any): Promise<boolean> {
    return await new Promise((resolve) => {
      let form = new FormData();
      form.append('avatar', avatar)
      this.http.post(serverurl + '/user/avatar', form).subscribe({
        next: (resdata: any) => {
          this.data.value.refreshtoken = new Date().getTime();
          this.data.value.avatar = 1;
          resolve(true);
        },
        error: (err) => {
          resolve(false);
        }
      });
    });
  }

  async getUserById(id: string): Promise<any> {
    return await new Promise((resolve) => {
      this.http.get(serverurl + '/auth/getuser/' + id).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (err) => {
          resolve(false);
        }
      });
    });
  }
  async getUserByIdShort(id: string): Promise<any> {
    return await new Promise((resolve) => {
      this.http.get(serverurl + '/auth/getusershort/' + id).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (err) => {
          resolve(false);
        }
      });
    });
  }
}
